import { motion } from 'framer-motion';
import { ClipboardCheck, Phone, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/common/PageHeader';
import ConsultationForm from '@/components/common/ConsultationForm';
import { usePageMeta, useServiceSchema } from '@/hooks/useSEO';

const VisaPreAssessmentPage = () => {
  usePageMeta(
    'Free Visa Pre-Assessment 2026 | Canada PR · Australia 189/190 · UK · Gulf — Zafco HR',
    'Free eligibility check for Canada Express Entry, Australia PR (189/190/491), UK Skilled Worker visa, and Gulf jobs. MEA-approved consultants, instant CRS / points scoring. 24-hour response.'
  );
  useServiceSchema({
    name: 'Free Visa Pre-Assessment',
    description:
      'Free instant eligibility check for Canada Express Entry, Australia PR (Subclass 189/190/491), UK Skilled Worker visa, Germany Opportunity Card and Gulf job placements.',
    serviceType: 'Immigration Consulting',
    areaServed: ['Canada', 'Australia', 'United Kingdom', 'Germany', 'Saudi Arabia', 'United Arab Emirates'],
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'INR',
      availability: 'https://schema.org/InStock',
    },
    url: 'https://zafco.in/visa-pre-assesment',
  });
  const openWhatsApp = () => {
    window.open('https://wa.me/919958848998?text=Hello%20Zafco,%20I%20need%20a%20visa%20pre-assessment', '_blank');
  };

  return (
    <div data-testid="visa-pre-assessment-page">
      <PageHeader 
        title="Free Visa Pre-Assessment"
        subtitle="Evaluate your eligibility for overseas jobs and immigration programs"
        breadcrumbs={[{ label: 'Visa Pre-Assessment' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-zafco-blue font-montserrat mb-6">
                Know Your Immigration Options
              </h2>
              <p className="text-gray-600 mb-6">
                Our free pre-assessment evaluates your profile against multiple immigration pathways 
                to identify the best options for your overseas career journey.
              </p>

              <div className="space-y-4 mb-8">
                {[
                  'Comprehensive profile evaluation',
                  'CRS/Points score calculation',
                  'Pathway recommendations',
                  'Timeline estimation',
                  'Cost breakdown',
                  'Personalized guidance',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={openWhatsApp}
                className="bg-gradient-to-r from-zafco-gold to-zafco-orange text-white"
              >
                <Phone className="w-5 h-5 mr-2" />
                Get Free Assessment
              </Button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 shadow-xl"
            >
              <h3 className="text-xl font-bold text-zafco-blue font-montserrat mb-6">
                Start Your Assessment
              </h3>
              <ConsultationForm />
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisaPreAssessmentPage;
